import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../DemoClient/Components/Card";
import { Button, Badge, Switch } from "retro";
import { Input } from "../../DemoClient/Components/Input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../DemoClient/Components/Table";
import { Search, Plus, Settings } from "lucide-react";
import { sampleCountries, binData, countryReferenceList } from "../../DemoClient/Data/mockData";
import { Label } from "../../DemoClient/Components/label";

export default function GeographyControl() {
    const [searchQuery, setSearchQuery] = useState("");
    const [regionFilter, setRegionFilter] = useState("all");
    const [statusFilter, setStatusFilter] = useState("all");

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({});
    const [editingId, setEditingId] = useState(null);
    const [countries, setCountries] = useState(sampleCountries);

    const filteredCountries = countries?.filter((country) => {
        const matchesSearch =
            country.countryName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            country.countryCode.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesRegion = regionFilter === "all" || country.region === regionFilter;
        const matchesStatus = statusFilter === "all" || country.status === statusFilter;
        return matchesSearch && matchesRegion && matchesStatus;
    });

    const getStatusBadge = (status) => {
        const commonStyle = { padding: "4px 8px", borderRadius: 4, fontSize: 12, fontWeight: 500 };
        switch (status) {
            case "allowed":
                return <Badge style={{ ...commonStyle, backgroundColor: "#D1FAE5", color: "#065F46" }}>Allowed</Badge>;
            case "blocked":
                return <Badge style={{ ...commonStyle, backgroundColor: "#FEE2E2", color: "#991B1B" }}>Blocked</Badge>;
            case "restricted":
                return <Badge style={{ ...commonStyle, backgroundColor: "#FEF3C7", color: "#92400E" }}>Restricted</Badge>;
            default:
                return <Badge style={{ ...commonStyle, border: "1px solid #D1D5DB" }}>{status}</Badge>;
        }
    };

    const getRiskBadge = (risk) => {
        switch (risk) {
            case "low":
                return <Badge appearance="added">Low</Badge>;
            case "medium":
                return <Badge appearance="important">Medium</Badge>;
            case "high":
                return <Badge appearance="removed">High</Badge>;
            default:
                return <Badge appearance="primary">{risk}</Badge>;
        }
    };


    const handleSave = () => {
        if (editingId) {
            setCountries((prev) =>
                prev.map((c) => (c.id === editingId ? { ...c, ...modalData } : c))
            );
        } else {
            setCountries((prev) => [
                ...prev,
                { ...modalData, id: Date.now().toString() }
            ]);
        }
        setShowModal(false);
        setModalData({});
        setEditingId(null);
    };

    const handleEdit = (country) => {
        setModalData({
            ...country,
            associatedBINs: country.associatedBINs || [],
        });
        setEditingId(country.id);
        setShowModal(true);
    };


    console.log(filteredCountries);
    return (
        <div style={{ marginTop: "1.5rem" }}>

            {/* Table */}
            <Card style={{ borderRadius: 8, border: "1px solid #E5E7EB" }}>
                <CardHeader style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    <CardTitle>Country Rules</CardTitle>

                    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center" }}>
                        <div style={{ position: "relative", flex: 1 }}>
                            <Search style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "#6B7280" }} />
                            <Input
                                placeholder="Search countries..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ width: "100%", paddingLeft: 32, height: 36 }}
                            />
                        </div>

                        <select value={regionFilter} onChange={(e) => setRegionFilter(e.target.value)} style={{ width: 180, height: 36, padding: "0 8px" }}>
                            <option value="all">All Regions</option>
                            <option value="GCC">GCC</option>
                            <option value="International">International</option>
                        </select>

                        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={{ width: 180, height: 36, padding: "0 8px" }}>
                            <option value="all">All Status</option>
                            <option value="allowed">Allowed</option>
                            <option value="blocked">Blocked</option>
                            <option value="restricted">Restricted</option>
                        </select>

                        <Button style={{ display: "flex", alignItems: "center", gap: 6, height: 36, padding: "0 12px" }} onClick={() => { setShowModal(true); setEditingId(null); setModalData({}); }}>
                            <Plus style={{ width: 16, height: 16 }} />
                            Add Country Rule
                        </Button>
                    </div>
                </CardHeader>

                <CardContent>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead style={{ fontWeight: 600 }}>Country</TableHead>
                                <TableHead style={{ fontWeight: 600 }}>Code</TableHead>
                                <TableHead style={{ fontWeight: 600 }}>Region</TableHead>
                                <TableHead style={{ fontWeight: 600 }}>Status</TableHead>
                                <TableHead style={{ fontWeight: 600 }}>Risk Level</TableHead>
                                <TableHead style={{ fontWeight: 600 }}>Sanctioned</TableHead>
                                <TableHead style={{ fontWeight: 600 }}>Associated BINs</TableHead>
                                <TableHead style={{ fontWeight: 600 }}>Actions</TableHead>
                            </TableRow>
                        </TableHeader>

                        <TableBody>
                            {filteredCountries.map((country) => (
                                <TableRow key={country.id}>
                                    <TableCell style={{ fontWeight: 500 }}>{country.countryName}</TableCell>
                                    <TableCell>{country.countryCode}</TableCell>
                                    <TableCell>{country.region}</TableCell>
                                    <TableCell>{getStatusBadge(country.status)}</TableCell>
                                    <TableCell>{getRiskBadge(country.riskLevel)}</TableCell>
                                    <TableCell>
                                        <Switch
                                            state={country.sanctioned}
                                            onChange={() => { }}
                                            style={{ cursor: "not-allowed", opacity: 0.6 }}
                                        />
                                    </TableCell>
                                    <TableCell>{country?.associatedBINs?.length}</TableCell>
                                    <TableCell>
                                        <Settings style={{ width: 16, height: 16, cursor: "pointer" }} onClick={() => handleEdit(country)} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>

            {/* Modal */}
            {showModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
                }}>
                    <div style={{ backgroundColor: '#fff', padding: 24, borderRadius: 8, width: 600, maxHeight: '90vh', overflowY: 'auto' }}>
                        <h3 style={{ margin: 0, marginBottom: 12 }}>{editingId ? "Edit Country Rule" : "Add Country Rule"}</h3>

                        <div style={{ display: 'grid', gap: 16 }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                <div>
                                    <label>Country Name</label>
                                    <select
                                        value={modalData.countryCode || ""}
                                        onChange={(e) => {
                                            const selectedCode = e.target.value;
                                          
                                            // Check if country already exists
                                            const existingCountry = countries.find(
                                              (c) => c.countryCode === selectedCode
                                            );
                                          
                                            if (existingCountry) {
                                              // Prefill existing data & switch to edit mode
                                              setModalData({
                                                ...existingCountry,
                                                associatedBINs: existingCountry.associatedBINs || [],
                                              });
                                              setEditingId(existingCountry.id);
                                            } else {
                                              // New country → basic prefill from reference list
                                              const selectedCountry = countryReferenceList.find(
                                                (c) => c.countryCode === selectedCode
                                              );
                                          
                                              setModalData({
                                                countryName: selectedCountry?.countryName || "",
                                                countryCode: selectedCountry?.countryCode || "",
                                                associatedBINs: [],
                                              });
                                              setEditingId(null);
                                            }
                                          }}
                                          
                                        style={{ width: '100%', padding: 8 }}
                                    >
                                        <option value="">Select Country</option>
                                        {countryReferenceList.map((country) => (
                                            <option key={country.countryCode} value={country.countryCode}>
                                                {country.countryName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label>Country Code</label>
                                    <Input
                                        value={modalData.countryCode || ""}
                                        disabled
                                        placeholder="Select Country to auto-fill Country Code"
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                <div>
                                    <label>Status</label>
                                    <select value={modalData.status || ""} onChange={e => setModalData({ ...modalData, status: e.target.value })} style={{ width: '100%', padding: 8 }}>
                                        <option value="">Select Status</option>
                                        <option value="allowed">Allowed</option>
                                        <option value="blocked">Blocked</option>
                                        <option value="restricted">Restricted</option>
                                    </select>
                                </div>
                                <div>
                                    <label>Risk Level</label>
                                    <select value={modalData.riskLevel || ""} onChange={e => setModalData({ ...modalData, riskLevel: e.target.value })} style={{ width: '100%', padding: 8 }}>
                                        <option value="">Select Risk Level</option>
                                        <option value="low">Low</option>
                                        <option value="medium">Medium</option>
                                        <option value="high">High</option>
                                    </select>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, alignItems: "center" }}>
                           
                                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                    <label>Sanctioned</label>
                                    <Switch state={modalData.sanctioned || false} onChange={() => setModalData({ ...modalData, sanctioned: !modalData.sanctioned })} />
                                </div>
                            </div>

                            <div style={{ position: "relative" }}>
                                <Label>Associated BINs</Label>

                                {/* Dropdown container */}
                                <div
                                    style={{
                                        border: "1px solid #D1D5DB",
                                        borderRadius: 4,
                                        padding: "8px",
                                        cursor: "pointer",
                                        backgroundColor: "#fff",
                                        maxHeight: 150,
                                        overflowY: "auto",
                                    }}
                                >
                                    {binData.map((bin) => (
                                        <div
                                            key={bin.id}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "4px 0",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={modalData.associatedBINs?.includes(bin.bin)}
                                                onChange={(e) => {
                                                    const newBins = e.target.checked
                                                        ? [...(modalData.associatedBINs || []), bin.bin]
                                                        : modalData.associatedBINs.filter((b) => b !== bin.bin);

                                                    setModalData({
                                                        ...modalData,
                                                        associatedBINs: newBins,
                                                    });
                                                }}
                                            />

                                            <span>{bin.bin} - {bin.brand} ({bin.cardType})</span>
                                        </div>
                                    ))}
                                </div>
                            </div>


                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                                <Button variant="outline" onClick={() => setShowModal(false)}>Cancel</Button>
                                <Button onClick={handleSave}>{editingId ? "Save Changes" : "Add Country"}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
